/**
 * Extracts a numeric value from the given input.
 * If the input is an object with a 'value' property, attempts to parse it as a float.
 * If the input is a primitive, attempts to parse it directly as a float.
 * Returns 0 if the parsed value is NaN.
 *
 * @param {object|string|number|null} obj - The input object or value to extract the number from.
 * @returns {number} The parsed numeric value, or 0 if parsing fails.
 */
export const getValue = (obj) => {
  if (typeof obj === "object" && obj !== null) {
    const val = parseFloat(obj.value);
    return isNaN(val) ? 0 : val;
  } else {
    const val = parseFloat(obj);
    return isNaN(val) ? 0 : val;
  }
};
